// `/settings/appearance` (account menu › Your settings › Appearance; SETUP-REGROUP): theme and
// sidebar, saved on this device, for every signed-in user, in the plain shell like `/account`.
// It was Setup › Appearance (`/c/{slug}/setup/appearance`, managers only), which now redirects
// here: a device preference is personal, not the company's (review #18).
import { createRoute, redirect } from "@tanstack/react-router";
import { companiesOf, isOperator } from "../features/company";
import { AppearanceScreen } from "../features/settings/appearance";
import { useSession } from "../features/use-feature";
import { PlainShell } from "../shell/app-shell";
import { authedRoute } from "./_authed";
import { setupRoute } from "./c.$slug.setup";

export const settingsAppearanceRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "settings/appearance",
  component: function Appearance() {
    const { api } = settingsAppearanceRoute.useRouteContext();
    const { me } = useSession();
    const current = isOperator(me) ? null : (companiesOf(me)[0]?.slug ?? null);
    return (
      <PlainShell me={me} api={api} current={current} main="full">
        <AppearanceScreen />
      </PlainShell>
    );
  },
});

/** The old Setup › Appearance URL. */
export const legacySetupAppearanceRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "appearance",
  beforeLoad: () => {
    throw redirect({ to: "/settings/appearance", replace: true });
  },
});

/**
 * `/settings/notifications` (wave 11b): the Your-settings address of SEARCH-NOTIF's page, which is
 * per company (`/c/{slug}/notifications`): it opens the first company's; with none, the company
 * picker.
 */
export const settingsNotificationsRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "settings/notifications",
  beforeLoad: ({ context }) => {
    const first = isOperator(context.me) ? undefined : companiesOf(context.me)[0];
    if (first)
      throw redirect({ to: "/c/$slug/notifications", params: { slug: first.slug }, replace: true });
    throw redirect({ to: "/", replace: true });
  },
});
